module.exports = {
  title: {
    textPageTitle: 'Text',
    graphicsPlay: 'Play',
    graphicsDrills: 'Drills',
    graphicsImages: 'Images',
    graphicsCoach: 'Coach',
    graphicsShop: 'Shop',
    graphicsHome: 'Home',
    graphicsFittings: 'Fittings',
  },
  filter: { language: 'Language' },
  buttonSync: 'Sync',
  buttonViewSheet: 'View Google Spreadsheet',
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    syncTransition: 'Are you sure you want to sync translation?',
    confirmPassword: 'Please input your password to confirm.',
    uploadImage: 'This will change the photo in the app. Are you sure you want to upload the image?',
    deleteImage: 'This will delete the photo in the app. Are you sure you want to upload the image?',
    deleteText: 'This will delete the text in the app. Are you sure you want to delete the text?',
  },
  btnUpdate: 'Update',
  btnCreate: 'Create',
  message: {
    syncTransitionSuccess: 'Translation successfully synced!',
    syncTransitionFailure: 'Translation sync failed',
    uploadImageSuccess: 'Image successfully uploaded.',
    deleteImageSuccess: 'Image successfully deleted.',
    updateImageSuccess: 'Image successfully updated.',
    downloadImageSuccess: 'Image successfully downloaded.',
    addUpdateImageFail: 'Add/Update image fail.',
    addUpdateTextFail: 'Add/Update text fail.',
    updateText: 'Text successfully updated.',
    createText: 'Text successfully added.',
    deleteText: 'Text successfully deleted.',
  },
  form: {
    keyImage: 'Key',
    urlImage: 'Url',
    keyText: 'Key Text',
    value: 'Value',
    imagePlaceholder: 'Upload or enter link',
  },
  validate: {
    keyImageBlank: 'Please input Key.',
    urlBlank: 'Please upload image.',
    keyTextBlank: 'Please input Key.',
    value: 'Please input Text.',
  },
  table: {
    title: {
      index: 'INDEX',
      link: 'IMAGE',
      action: 'ACTION',
      key: 'KEY',
      value: 'VALUE',
    },
    action: {
      download: 'Download original image',
      upload: 'Upload image',
      delete: 'Delete image',
      edit: 'Edit',
    },
  },
};
